export const AGED_UP_MINOR_OPTION = 'Aged up Minor';

export const filterApplicantTypes = ({
  applicantTypesOptions = [],
  agingUpMinors = false,
  isPrimary = false,
}) => {
  return applicantTypesOptions?.filter((item) => {
    if (item.text === AGED_UP_MINOR_OPTION) {
      return agingUpMinors && !isPrimary;
    }
    return true;
  });
};
